module.exports = __webpack_public_path__ + "static/media/promotional_simple.a56614dd.png";